export default __webpack_public_path__ + "static/media/trainer-app.f8a606d7.png";